import * as types from './actionTypes/loading';

export interface ILoadingActionType {
    type: typeof types.FETCHING_STARTED | typeof types.FETCHING_ENDED;
    payload: boolean;
}

export const startLoading = () => ({ type: types.FETCHING_STARTED, payload: true, });
export const endLoading = () => ({ type: types.FETCHING_ENDED, payload: false, });
